import { useState } from "react";
import { Box } from "@mui/material";
import { Lock } from "@phosphor-icons/react";
import { Button } from "./../button/button";
import { ModalV2 } from "../modal/modal";
import { NormalText, TextFieldStyled } from "../styles";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../redux/actions/user.actions";
import { Announcement } from "../announcement/announcement";

export const ModalAuthenticator = ({
  email,
  username,
  password,
  showModal,
  handleShowModal,
}) => {
  const [code, setCode] = useState("");

  const { isLoading: isLoadingUser, error: errorUser } = useSelector(
    (state) => state.user
  );

  const dispatch = useDispatch();

  function handleVerify() {
    dispatch(login(username, password, code));
  }

  const handleChange = (e) => {
    if (e.key === "Enter") {
      handleVerify();
      return;
    }
    setCode(e.target.value);
  };

  return (
    <ModalV2 isOpen={showModal} handleClose={handleShowModal}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={"16px"}
      >
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          p={"8px"}
          borderRadius={"100%"}
          width={"100px"}
          height={"100px"}
          bgcolor={"#0f110b"}
        >
          <Lock size={48} color="#EDEDED" weight="fill" />
        </Box>
        <NormalText size={24} color={"#0F110C"} isBold>
          Enter verification code
        </NormalText>
        <NormalText size={14}>
          We've sent a code to <strong>{email}</strong>
        </NormalText>
        <Box display={"flex"} gap={"8px"}>
          <TextFieldStyled
            value={code}
            onChange={handleChange}
            onKeyDown={handleChange}
            inputProps={{
              maxLength: 6,
              style: {
                textAlign: "center",
                fontSize: "2rem",
                width: "180px",
                transition: "border-color 0.2s",
              },
            }}
            sx={{
              "& .MuiInputBase-root": {
                border: "1px solid #CBCBCB",
                backgroundColor: "transparent",
                borderRadius: "8px",
                "&.Mui-focused": {
                  borderColor: "#0197f6",
                },
                "& .MuiInputBase-input": {
                  padding: "8px",
                  backgroundColor: "transparent",
                },
              },
              width: "180px",
            }}
            variant="outlined"
          />
        </Box>
        <Box display={"flex"} gap={"8px"}>
          <Button
            label="Close"
            type="outlined"
            onClick={handleShowModal}
            buttonStyles={{
              padding: "8px 40px !important",
            }}
          />
          <Button
            label="Verify"
            onClick={handleVerify}
            buttonStyles={{
              padding: "8px 40px !important",
              minHeight: "39px",
              minWidth: "123px",
            }}
            containerStyles={{
              minWidth: "123px",
            }}
            isLoading={isLoadingUser}
          />
        </Box>
        {errorUser && !errorUser?.includes("@") && (
          <Box mx={"64px"}>
            <Announcement
              title={"Error"}
              description={errorUser}
              type={"error"}
            />
          </Box>
        )}
      </Box>
    </ModalV2>
  );
};
